export const SITE = {
  name: "Burger Blenger",
  altName: "Blenger Burger",
  slogan: "It's Worth The Wait",
  founded: "2004",
  founder: "Erik Kadarman",
  origin: "Barito – Blok M, Jakarta Selatan",
  instagram: "https://www.instagram.com/blengerburger.id/",
  instagramHandle: "@blengerburger.id",
  address: {
    street: "Jl. Bumi No. 56",
    locality: "Kebayoran Baru, Jakarta Selatan",
    region: "DKI Jakarta",
    country: "Indonesia",
  },
};

export const IMAGES = {
  hero: {
    src: "https://images.unsplash.com/photo-1565299507177-b0ac66763828?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&h=1125&fit=crop",
    w: 900,
    h: 1125,
    alt: "Burger Blenger — burger dengan smoked beef dan saus keju luber khas lapak Blok M",
  },
  cheeseX2: {
    src: "https://images.pexels.com/photos/29332505/pexels-photo-29332505.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop",
    w: 800,
    h: 600,
    alt: "Cheese Burger X2 dengan saus melimpah di atas nampan lapak",
  },
  cheeseBurger: {
    src: "https://images.unsplash.com/photo-1606131731446-5568d87113aa?crop=entropy&cs=srgb&fm=jpg&q=85&w=800&h=600&fit=crop",
    w: 800,
    h: 600,
    alt: "Cheese burger dengan patty sapi, keju leleh, dan siraman saus BBQ",
  },
  beefBurger: {
    src: "https://images.unsplash.com/photo-1598182198871-d3f4ab4fd181?crop=entropy&cs=srgb&fm=jpg&q=85&w=800&h=600&fit=crop",
    w: 800,
    h: 600,
    alt: "Beef burger dengan bun wijen dan saus yang menetes",
  },
  chilliDog: {
    src: "https://images.pexels.com/photos/36501082/pexels-photo-36501082.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop",
    w: 800,
    h: 600,
    alt: "Chilli dog dengan taburan gurih dan dua saus cocolan",
  },
  cheesyDog: {
    src: "https://images.unsplash.com/photo-1768251036450-a66f4680d410?crop=entropy&cs=srgb&fm=jpg&q=85&w=800&h=600&fit=crop",
    w: 800,
    h: 600,
    alt: "Hot dog dengan lelehan saus keju creamy",
  },
  streetNight: {
    src: "https://images.pexels.com/photos/15699990/pexels-photo-15699990.jpeg?auto=compress&cs=tinysrgb&w=1000&h=700&fit=crop",
    w: 1000,
    h: 700,
    alt: "Suasana lapak kaki lima di malam hari",
  },
  stallBW: {
    src: "https://images.unsplash.com/photo-1713927521697-fed72faf6745?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000&h=700&fit=crop",
    w: 1000,
    h: 700,
    alt: "Penjual di lapak makanan malam, hitam putih",
  },
};

export const MENU = [
  {
    category: "Burger",
    note: "Bun & patty dibuat sendiri",
    items: [
      {
        id: "beef-burger",
        name: "Beef Burger",
        desc: "Patty sapi homemade yang juicy, roti bun panggang, siraman saus mayo-BBQ khas Blenger.",
      },
      {
        id: "cheese-burger",
        name: "Cheese Burger",
        desc: "Klasik yang bikin nama Blenger besar: patty juicy, keju leleh, saus melimpah.",
      },
      {
        id: "cheese-burger-x2",
        name: "Cheese Burger X2",
        desc: "Dobel nikmat: patty sapi, telur, smoked beef, dan keju leleh berlapis. Yang paling diburu.",
        tag: "Favorit",
      },
    ],
  },
  {
    category: "Hot Dog",
    note: "Disiram saus sampai luber",
    items: [
      {
        id: "chilli-dog",
        name: "Chilli Dog",
        desc: "Sosis dalam roti lembut, disiram saus chili gurih dengan tendangan pedas.",
      },
      {
        id: "cheesy-dog",
        name: "Cheesy Dog",
        desc: "Hot dog dengan lelehan saus keju creamy yang luber di tiap gigitan.",
      },
      {
        id: "chilli-dog-xl",
        name: "Chilli Dog XL",
        desc: "Chilli dog ukuran ekstra. Khusus buat yang laparnya serius.",
        tag: "Jumbo",
      },
    ],
  },
];

export const OUTLETS = [
  {
    id: "blok-m",
    name: "Blok M (Pusat)",
    area: "Jl. Bumi No. 56, Kebayoran Baru, Jakarta Selatan",
    maps: "https://www.google.com/maps/search/?api=1&query=Burger+Blenger+Jl.+Bumi+No.56+Kebayoran+Baru+Jakarta+Selatan",
  },
  {
    id: "fatmawati",
    name: "Fatmawati – Pondok Labu",
    area: "Kawasan Jl. RS Fatmawati, Jakarta Selatan",
    maps: "https://www.google.com/maps/search/?api=1&query=Blenger+Burger+Fatmawati+Jakarta+Selatan",
  },
  {
    id: "bintaro",
    name: "Bintaro",
    area: "Bintaro, Tangerang Selatan",
    maps: "https://www.google.com/maps/search/?api=1&query=Blenger+Burger+Bintaro",
  },
  {
    id: "bsd",
    name: "BSD",
    area: "BSD, Tangerang Selatan",
    maps: "https://www.google.com/maps/search/?api=1&query=Blenger+Burger+BSD+Tangerang+Selatan",
  },
];

export const MAPS_EMBED =
  "https://maps.google.com/maps?q=Burger%20Blenger%20Jl.%20Bumi%20No.%2056%20Kebayoran%20Baru%20Jakarta%20Selatan&t=&z=15&ie=UTF8&iwloc=&output=embed";

export const FAQS = [
  {
    id: "arti-blenger",
    q: "Apa arti nama “Blenger”?",
    a: "“Blenger” diambil dari bahasa Jawa yang artinya kenyang berlebih sampai puas maksimal. Nama itu dipilih untuk menggambarkan porsi burger yang besar dan saus yang melimpah — standar yang dipakai sejak lapak pertama tahun 2004.",
  },
  {
    id: "lokasi-outlet",
    q: "Di mana saja outlet Burger Blenger?",
    a: "Outlet pusat ada di Jl. Bumi No. 56, kawasan Barito–Blok M, Kebayoran Baru, Jakarta Selatan. Burger Blenger juga hadir di kawasan Fatmawati–Pondok Labu, Bintaro, dan BSD (Tangerang Selatan). Cek halaman Lokasi untuk petunjuk arah.",
  },
  {
    id: "jam-buka",
    q: "Jam berapa Burger Blenger buka?",
    a: "Jam operasional bisa berbeda di tiap outlet dan bisa berubah dari waktu ke waktu. Untuk info paling baru, cek Instagram @blengerburger.id atau lihat langsung di Google Maps sebelum berangkat.",
  },
  {
    id: "pesan-antar",
    q: "Bisa pesan antar online?",
    a: "Bisa. Burger Blenger umumnya tersedia di aplikasi pesan-antar online — cukup cari “Burger Blenger” atau “Blenger Burger” di aplikasi favoritmu, sesuai area outlet terdekat.",
  },
  {
    id: "kemitraan",
    q: "Apakah Burger Blenger membuka franchise?",
    a: "Burger Blenger secara historis dikelola mandiri oleh pemiliknya dan sangat selektif soal kemitraan. Kalau kamu serius ingin bermitra, cara terbaik adalah menghubungi manajemen langsung lewat Instagram @blengerburger.id.",
  },
  {
    id: "harga",
    q: "Berapa harga menu Burger Blenger?",
    a: "Harga Burger Blenger terkenal ramah kantong untuk ukuran porsinya. Daftar harga terbaru bisa berbeda di tiap outlet dan berubah dari waktu ke waktu — cek langsung di outlet atau aplikasi pesan-antar.",
  },
];
